import type { ReactNode } from "react";
import { Skeleton } from "@mui/material";

function EtablissementPublicMapSkeleton(): ReactNode {
  return <Skeleton variant="rectangular" width="100%" height="20rem" sx={{ borderRadius: 2 }} />;
}

export default EtablissementPublicMapSkeleton;
